import { ActivityTypes } from '../Models/ActivityConstants';
import { ActivityModel } from '../Models/FlowModel';
import { FlowNode } from '../Models/GraphModel';

export const COMPACT_AGENT_SERVICE_SIZE = 32;
export const DEFAULT_BLOCK_WIDTH = 240;
export const DEFAULT_BLOCK_HEIGHT = 160;
export const DEFAULT_GROUP_WIDTH = 220;

export function isBlockToolContentHidden(activity: ActivityModel): boolean {
	return activity.Type === ActivityTypes.BLOCK_TOOL && (activity.Metadata?.collapsed === true || activity.Metadata?.compact === true);
}

export function isContainerContentHidden(activity: ActivityModel): boolean {
	return activity.Type === ActivityTypes.GROUP_TOOL || isBlockToolContentHidden(activity);
}

export function isHiddenByParentContainer(node: FlowNode, nodesById: Map<string, FlowNode>): boolean {
	let parentId = node.parentId;
	while (parentId) {
		const parent = nodesById.get(parentId);
		if (!parent) return false;
		if (isContainerContentHidden(parent.data)) return true;
		parentId = parent.parentId;
	}
	return false;
}

export function updateAgentServiceCompact(nodes: FlowNode[], id: string, compact: boolean, data: Partial<ActivityModel> = {}): FlowNode[] {
	const updatedNodes = nodes.map((node) => {
		if (node.id !== id) return node;

		const metadata = node.data.Metadata ?? {};
		const wasCompact = metadata.compact === true;
		if (wasCompact === compact) return node;

		const nextMetadata = {
			...metadata,
			...data.Metadata,
			compact,
			...(compact && node.type === 'block' ? {
				width: node.width ?? metadata.width ?? DEFAULT_BLOCK_WIDTH,
				height: node.height ?? metadata.height ?? DEFAULT_BLOCK_HEIGHT,
			} : {}),
		};
		return {
			...node,
			...(node.type === 'block' ? {
				width: compact ? COMPACT_AGENT_SERVICE_SIZE : (nextMetadata.width as number) ?? DEFAULT_BLOCK_WIDTH,
				height: compact ? COMPACT_AGENT_SERVICE_SIZE : (nextMetadata.height as number) ?? DEFAULT_BLOCK_HEIGHT,
			} : node.type === 'groupTool' ? {
				width: compact ? COMPACT_AGENT_SERVICE_SIZE : DEFAULT_GROUP_WIDTH,
			} : {}),
			data: { ...node.data, ...data, Metadata: nextMetadata },
		};
	});

	const nodesById = new Map(updatedNodes.map((node) => [node.id, node]));
	return updatedNodes.map((node) => {
		if (!node.parentId) return node;
		const hidden = isHiddenByParentContainer(node, nodesById);
		return node.hidden === hidden && (!hidden || !node.selected) ? node : { ...node, hidden, selected: hidden ? false : node.selected };
	});
}
